import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';


class ReportErrorHandler extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    error: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {error: false};
  }
  componentDidCatch(error) {
    console.log(error);
    this.setState({error: true});
  }
  render() {

    if (this.state.error || this.props.error) {
      return <div>
        <label className="report-error"><FormattedMessage id='report.could.not.load' /></label>
      </div>;
    }
    return this.props.children;
  }
}

export default ReportErrorHandler;
